import React from "react";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

const icons = {
  defense: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3l7 4v5c0 5-3.5 8-7 9-3.5-1-7-4-7-9V7l7-4Z"
      />
    </svg>
  ),
  healthcare: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <rect x="3" y="7" width="18" height="13" rx="2" strokeWidth="1.8" />
      <path strokeWidth="1.8" strokeLinecap="round" d="M12 11v5M9.5 13.5h5" />
      <path strokeWidth="1.8" d="M9 7V5a3 3 0 016 0v2" />
    </svg>
  ),
  agencies: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 20h16M6 20V10l6-4 6 4v10M9 20v-5h6v5"
      />
    </svg>
  ),
  infrastructure: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path strokeWidth="1.8" d="M4 19h16M7 19V9l5-4 5 4v10" />
      <path strokeWidth="1.8" d="M9 19v-4h6v4" />
    </svg>
  ),
  facilities: (
    <svg
      className="w-6 h-6 text-blue-600"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <rect x="4" y="3" width="16" height="18" rx="2" strokeWidth="1.8" />
      <path strokeWidth="1.8" d="M8 7h2M14 7h2M8 11h2M14 11h2M8 15h2M14 15h2M11 21v-4h2v4" />
    </svg>
  ),
  technology: (
    <svg
      className="w-6 h-6 text-purple-600"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <rect x="3" y="4" width="18" height="12" rx="2" strokeWidth="1.8" />
      <path strokeWidth="1.8" d="M8 20h8M10 16v4M14 16v4" />
    </svg>
  ),
  emergency: (
    <svg
      className="w-6 h-6 text-red-600"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path strokeWidth="1.8" d="M12 3v6M12 15v6M3 12h6M15 12h6" />
      <circle cx="12" cy="12" r="2.5" strokeWidth="1.8" />
    </svg>
  ),
  logistics: (
    <svg
      className="w-6 h-6 text-green-600"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <rect x="3" y="7" width="13" height="9" rx="1" strokeWidth="1.8" />
      <path strokeWidth="1.8" d="M16 10h3l2 2v4h-5" />
      <circle cx="7" cy="18" r="2" strokeWidth="1.8" />
      <circle cx="18" cy="18" r="2" strokeWidth="1.8" />
    </svg>
  ),
  laundry: (
    <svg
      className="w-6 h-6 text-amber-600"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <rect x="3" y="4" width="18" height="16" rx="2" strokeWidth="1.8" />
      <circle cx="12" cy="13" r="4" strokeWidth="1.8" />
      <path strokeWidth="1.8" d="M8 7h.01M12 7h.01M16 7h.01" />
    </svg>
  ),
  strategy: (
    <svg
      className="w-6 h-6 text-[#2C3E50]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="8" strokeWidth="1.8" />
      <circle cx="12" cy="12" r="2.5" strokeWidth="1.8" />
      <path strokeWidth="1.8" d="M12 4v2M12 18v2M4 12h2M18 12h2" />
    </svg>
  ),
  funding: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3l7 4v5c0 5-3.5 8-7 9-3.5-1-7-4-7-9V7l7-4Z"
      />
    </svg>
  ),
  teaming: (
    <svg
      className="w-6 h-6 text-[#2C3E50]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M10 11a4 4 0 100-8 4 4 0 000 8ZM20 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"
      />
    </svg>
  ),
  techAdvantage: (
    <svg
      className="w-6 h-6 text-[#2C3E50]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <rect x="3" y="4" width="18" height="12" rx="2" strokeWidth="1.8" />
      <path strokeWidth="1.8" d="M8 20h8M10 16v4M14 16v4" />
    </svg>
  ),
  veteran: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3l2.2 4.45L19 8.2l-3.5 3.4.82 4.8L12 14.2l-4.32 2.2.82-4.8L5 8.2l4.8-.75L12 3Z"
      />
    </svg>
  ),
  compliance: (
    <svg
      className="w-6 h-6 text-[#2C3E50]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 12l2 2 4-4"
      />
      <rect x="4" y="3" width="16" height="18" rx="2" strokeWidth="1.8" />
    </svg>
  ),
  reach: (
    <svg
      className="w-6 h-6 text-[#2C3E50]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="8" strokeWidth="1.8" />
      <path strokeWidth="1.8" d="M4 12h16M12 4a14 14 0 010 16M12 4a14 14 0 000 16" />
    </svg>
  ),
  check: (
    <svg
      className="w-4 h-4 text-[#C5A047] mt-0.5 flex-shrink-0"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M5 12l5 5L20 7" />
    </svg>
  ),
};

const sectors = [
  {
    icon: icons.defense,
    title: "Defense & Security",
    clients: ["Department of Defense", "Homeland Security", "Intelligence Community"],
  },
  {
    icon: icons.healthcare,
    title: "Healthcare",
    clients: ["VA Medical Centers", "Defense Health Agency", "Public Health Services"],
  },
  {
    icon: icons.agencies,
    title: "State & Federal Agencies",
    clients: ["Federal Emergency Management", "State & Local Governments"],
  },
  {
    icon: icons.infrastructure,
    title: "Infrastructure",
    clients: ["Public Utilities", "Transportation", "Facilities Management"],
  },
];

const coreCapabilities = [
  {
    to: "/services/facilities",
    title: "Facility Management & Support Services",
    icon: icons.facilities,
    cardClass:
      "bg-gradient-to-br from-blue-50 to-blue-100/50 border border-blue-200 hover:border-blue-300",
    accentClass: "border-blue-200",
    textClass: "text-blue-600 group-hover:text-blue-700",
  },
  {
    to: "/services/technology",
    title: "IT & Technology Services",
    icon: icons.technology,
    cardClass:
      "bg-gradient-to-br from-purple-50 to-purple-100/50 border border-purple-200 hover:border-purple-300",
    accentClass: "border-purple-200",
    textClass: "text-purple-600 group-hover:text-purple-700",
  },
  {
    to: "/services/emergency",
    title: "Emergency Response & Disaster Recovery",
    icon: icons.emergency,
    cardClass:
      "bg-gradient-to-br from-red-50 to-red-100/50 border border-red-200 hover:border-red-300",
    accentClass: "border-red-200",
    textClass: "text-red-600 group-hover:text-red-700",
  },
  {
    to: "/services/logistics",
    title: "Logistics & Groundskeeping Services",
    icon: icons.logistics,
    cardClass:
      "bg-gradient-to-br from-green-50 to-green-100/50 border border-green-200 hover:border-green-300",
    accentClass: "border-green-200",
    textClass: "text-green-600 group-hover:text-green-700",
  },
  {
    to: "/services/laundry",
    title: "Laundry & Linen Services",
    icon: icons.laundry,
    cardClass:
      "bg-gradient-to-br from-amber-50 to-amber-100/50 border border-amber-200 hover:border-amber-300",
    accentClass: "border-amber-200",
    textClass: "text-amber-600 group-hover:text-amber-700",
  },
  {
    to: null,
    title: "Federal Capture Strategy",
    icon: icons.strategy,
    cardClass:
      "bg-gradient-to-br from-gray-50 to-gray-100/50 border border-gray-300 hover:border-gray-400",
    accentClass: "border-gray-300",
    textClass: "text-[#2C3E50]",
    footerText: "Strategic Consulting",
  },
];

const Capabilities = () => {
  return (
    <>
      <SEO
        title="Our Capabilities | Providence Federal Group"
        description="Discover our SDVOSB capabilities in government contracting, project management, and federal compliance."
        keywords="capabilities, SDVOSB, government contracts, project management, federal compliance"
      />

      <div className="min-h-screen bg-white">
        <Header />

        {/* HERO */}
        <section className="bg-gradient-to-r from-[#2C3E50] via-[#2C3E50] to-[#1A365D] text-white pt-40 pb-24">
          <div className="max-w-7xl mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight mt-20" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              What Sets Us Apart
            </h1>
            <p className="text-xl md:text-2xl max-w-4xl mx-auto leading-relaxed">
              Providence Federal Group is built on
              <span className="font-semibold text-[#C5A047]">
                &nbsp;disciplined execution and opereational reliability
              </span>
              . We deliver consistent, high-quality support by combining the agility of a small business with structured process and strong service standards.
            </p>
            <p className="text-xl md:text-2xl max-w-4xl mx-auto leading-relaxed mt-5">
              Our focus is simple: <span className="font-semibold text-[#C5A047]">be responsive, be accountable, and execute effectively</span> across every enegagement.
            </p>
          </div>
        </section>

        {/* OUR CAPABILITIES */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                Our Federal Services Capabilities
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Providence Federal Group delivers operational support services to federal and commercial clients,
                including grounds maintenace, janitorial services, base operations support, and related professional services.
              </p>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-3">
                We emphasize reliable execution, responsive service, and consistent performance across every engagement.
              </p>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-3">
                As a certified SDVOSB, we combine agility with the structure and accountability required in government contracting.
              </p>
            </div>

            {/* Certifications */}
            <div className="text-center mb-12">
              <span className="inline-block px-4 py-1 bg-[#C5A047]/10 text-[#C5A047] text-sm font-semibold rounded-full mb-3">
                CERTIFICATIONS
              </span>
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                SBA-Certified Business
              </h3>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
              {[
                {
                  image: "/images/certifications/wosb-certified.png",
                  alt: "Woman-Owned Small Business Certified",
                  title: "WOSB Certified",
                  description:
                    "U.S. Small Business Administration Certified Woman-Owned Small Business",
                },
                {
                  image: "/images/certifications/sdvosb-certified.png",
                  alt: "Service-Disabled Veteran-Owned Small Business Certified",
                  title: "SDVOSB Certified",
                  description:
                    "Service-Disabled Veteran-Owned Small Business Certification",
                },
                {
                  image: "/images/certifications/veteran-owned-certified.png",
                  alt: "Veteran-Owned Certified",
                  title: "Veteran-Owned Certified",
                  description:
                    "U.S. Small Business Administration Certified Veteran-Owned Business",
                },
                {
                  image: "/images/certifications/edwosb-certified.png",
                  alt: "Economically Disadvantaged Woman-Owned Small Business Certified",
                  title: "EDWOSB Certified",
                  description:
                    "Economically Disadvantaged Woman-Owned Small Business Certification",
                },
              ].map((cert, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl shadow-lg border border-gray-100 flex flex-col items-center text-center hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="w-full h-48 mb-6 rounded-lg overflow-hidden shadow-md bg-white flex items-center justify-center p-4">
                    <img
                      src={cert.image}
                      alt={cert.alt}
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <h3 className="text-xl font-bold text-[#2C3E50] mb-3">
                    {cert.title}
                  </h3>
                  <p className="text-gray-600 text-sm">{cert.description}</p>
                </div>
              ))}
            </div>

            {/* Mission-Critical Organizations */}
            <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-10 rounded-2xl shadow-inner">
              <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                We Serve Mission-Critical Organizations
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {sectors.map((sector, index) => (
                  <div
                    key={index}
                    className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow"
                  >
                    <div className="mb-3">{sector.icon}</div>
                    <h4 className="font-bold text-gray-800 mb-3">{sector.title}</h4>
                    <ul className="space-y-2">
                      {sector.clients.map((client, i) => (
                        <li
                          key={i}
                          className="flex items-start gap-2 text-sm text-gray-600"
                        >
                          {icons.check}
                          <span>{client}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CORE CAPABILITIES */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                Core Capabilities Aligned with National Needs
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                We focus on high-demand service lines where our veteran-owned
                status, compliance rigor, and operational excellence deliver
                distinct advantage.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {coreCapabilities.map((item, index) => {
                const content = (
                  <>
                    <div className="flex items-start mb-4">
                      <div className="w-12 h-12 rounded-lg flex items-center justify-center mr-4 bg-white/70">
                        {item.icon}
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-[#2C3E50] transition-colors">
                          {item.title}
                        </h3>
                      </div>
                    </div>

                    <div className={`mt-4 pt-4 border-t ${item.accentClass}`}>
                      <span className={`text-sm font-medium transition-colors ${item.textClass}`}>
                        {item.footerText || "Explore Services →"}
                      </span>
                    </div>
                  </>
                );

                if (item.to) {
                  return (
                    <Link
                      key={index}
                      to={item.to}
                      className={`group p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 ${item.cardClass}`}
                    >
                      {content}
                    </Link>
                  );
                }

                return (
                  <div
                    key={index}
                    className={`group p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 ${item.cardClass}`}
                  >
                    {content}
                  </div>
                );
              })}
            </div>

            <div className="text-center mt-12">
              <p className="text-gray-500 text-sm italic">
                Click on any service to explore detailed capabilities and offerings
              </p>
            </div>
          </div>
        </section>

        {/* EXECUTION & PARTNERSHIPS */}
        {<section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4">
            {/* <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  How We Win: Precision Execution
                </h2>
                <p className="text-lg text-gray-600 mb-8">
                  Our winning methodology combines strategic positioning with
                  operational discipline. We&apos;re not just chasing
                  contracts—we&apos;re building sustainable partnerships.
                </p>

                <div className="space-y-6">
                  {executionPoints.map((point, index) => (
                    <div key={index} className="flex items-start">
                      <div
                        className={`flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center mr-4 ${point.iconBg}`}
                      >
                        {point.icon}
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-2">{point.title}</h4>
                        <p className="text-gray-600">{point.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-white p-10 rounded-2xl shadow-xl border border-gray-200">
                <h3 className="text-2xl font-bold text-gray-900 mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  Our Strategic Advantages
                </h3>

                <div className="space-y-6">
                  {strategicAdvantages.map((item, index) => (
                    <div
                      key={index}
                      className="flex items-center p-4 bg-white rounded-xl shadow-sm"
                    >
                      <div
                        className={`w-12 h-12 rounded-lg flex items-center justify-center mr-4 ${item.iconBg}`}
                      >
                        {item.icon}
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900">{item.title}</h4>
                        <p className="text-sm text-gray-600">{item.description}</p>
                      </div>
                    </div>
                  ))}

                  <div className="pt-6 border-t border-gray-200">
                    <p className="text-sm text-gray-500 italic">
                      &quot;Our certifications and strategic approach provide
                      competitive advantages in federal procurement, particularly
                      for mission-critical service contracts.&quot;
                    </p>
                  </div>
                </div>
              </div>
            </div> */}
            {/* CTA */}
            <div className="bg-gradient-to-r from-[#1E3A8A] to-[#2C3E50] rounded-2xl p-8 md:p-12 text-white text-center shadow-xl">
              <div className="max-w-3xl mx-auto">
                <div className="flex justify-center mb-6">
                  <div className="w-16 h-1 bg-[#C5A047]"></div>
                </div>

                <h3
                  className="font-display text-3xl md:text-4xl font-medium mb-6"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  Ready to Partner with Purpose?
                </h3>

                <p className="text-lg md:text-xl mb-8 text-white/90 leading-relaxed">
                  Let&apos;s discuss how our certified capabilities and mission-focused
                  approach can support your agency&apos;s objectives.
                </p>

                <div className="flex flex-col sm:flex-row justify-center gap-4">
                  <Link
                    to="/contact"
                    className="px-8 py-4 bg-[#C5A047] text-white font-semibold rounded-full hover:bg-[#D4AF37] transition-all shadow-lg inline-flex items-center justify-center"
                  >
                    <svg
                      className="w-5 h-5 mr-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      />
                    </svg>
                    Request a Capabilities Brief
                  </Link>

                  <a
                    href="tel:14013469778"
                    className="px-8 py-4 bg-white/10 text-white font-semibold rounded-full hover:bg-white/20 transition-all border border-white/20 inline-flex items-center justify-center"
                  >
                    <svg
                      className="w-5 h-5 mr-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M3 5.5C3 4.12 4.12 3 5.5 3h2.2a2 2 0 011.94 1.515l.516 2.066a2 2 0 01-.45 1.948l-1.27 1.27a16 16 0 006.586 6.586l1.27-1.27a2 2 0 011.948-.45l2.066.516A2 2 0 0121 16.72V19a2 2 0 01-2 2h-1C10.716 21 3 13.284 3 6V5.5z"
                      />
                    </svg>
                    Call Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>}
      </div>
    </>
  );
};

export default Capabilities;